export default __webpack_public_path__ + "static/media/sad_non-binary.0a88b73c.png";